import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import sanitizeHtml from 'sanitize-html';
import { Link } from 'react-router-dom';

import { toast } from 'react-toastify';
import { AppDispatch } from '../store/store';
import { fetchTermIsAccepted, termIsAcceptedValueUpdated } from '../store/auth/authSlice';
import { accountApi } from '../api';
import { Term } from '../api/openapi';

const Terms = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState<Term | null>(null);
  const { t } = useTranslation(['terms', 'common']);
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const loadTerms = async () => {
    setLoading(true);
    try {
      const response = await accountApi.termRetrieve({
        uuid: 'latest',
      });

      setData(response.data);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTerms();
  }, []);

  const accept = async () => {
    if (data != null) {
      setSubmitting(true);
      try {
        await accountApi.termAccept({
          uuid: data.id,
        });

        dispatch(termIsAcceptedValueUpdated(true));
        dispatch(fetchTermIsAccepted());
      } catch {
        setSubmitting(false);
        toast.error(t('common:kerfisvilla'));
      }
    }
  };

  return (
    <Container className="pt-5">
      <strong className="text-center mt-3 d-block" style={{ textTransform: 'uppercase' }}>
        {t('title')}
      </strong>

      <Row className="justify-content-center">
        <Col xl="8" lg="10" md="6">
          <Card className="o-hidden my-3 border-0">
            <div className="p-4">
              {error ? (
                <div className="text-center">{t('common:kerfisvilla')}</div>
              ) : loading ? (
                <div className="text-center">
                  <FontAwesomeIcon icon={faSpinner} spin />
                </div>
              ) : !data ? (
                <div className="text-center">{t('common:noDataFound')}</div>
              ) : (
                <>
                  {!data.acceptedAt && <p>{t('mustAccept')}</p>}

                  <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.textHtml || '') }} />

                  {data.acceptedAt ? (
                    <div className="text-center mt-2">
                      <p>{t('alreadyAccepted')}</p>
                      <p>
                        <Link to="/">{t('common:goToFrontPage')}</Link>
                      </p>
                    </div>
                  ) : (
                    <>
                      <Form.Group className="mb-3" controlId="iHaveReadAndAccept">
                        <Form.Check type="checkbox" label={t('iHaveReadAndAccept')} checked={checked} onChange={(e) => setChecked(e.target.checked)} />
                      </Form.Group>
                      <Button variant="primary" className="w-100" disabled={!checked || submitting} onClick={accept}>
                        {submitting && <FontAwesomeIcon icon={faSpinner} spin />} {t('submit')}
                      </Button>
                    </>
                  )}
                </>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Terms;
